import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { apiClient } from '../../utils/axiosAdvanced';
import { socketNewEvent } from './eventsSlice';

export const searchEventAssetId = createAsyncThunk(
    'events/searchEventsAssetId',
    async ({ assetId, fromDate, toDate }, thunkAPI) => {
        try {
            const reqData = {
                assetid: assetId,
                fromDate: fromDate ?? moment().subtract(1, 'days').format('YYYY-MM-DD hh:mm:ss'),
                toDate: toDate ?? moment().format('YYYY-MM-DD HH:mm:ss'),
                limit: 175,
                offset: 0
            };
            console.log("Search events for asset api req data", reqData);
            const apiData = await apiClient.post('/get_events_assetid', reqData);
            console.log("Events for asset api", apiData.data);
            return checkEventUserid(apiData.data.events, thunkAPI.getState, 175);
        } catch (error) {
            //console.log("Get events one asset error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const searchEventsMulti = createAsyncThunk(
    'events/searchEventsMulti',
    async ({ vehicleName, fromDate, toDate, eventDesc, limit, offset }, thunkAPI) => {
        try {
            let reqData = {
                vehicleName: vehicleName ?? null,
                fromDate: fromDate,
                toDate: toDate,
                eventDesc: eventDesc,
                limit: limit,
                offset: offset,
            };
            const apiData = await apiClient.post('/search_events_multi', reqData);
            console.log("Search events multi api", apiData.data);
            return checkEventUserid(apiData.data.events, thunkAPI.getState, limit);
        } catch (error) {
            //console.log("Search events multi error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const defaultEventsLoad = createAsyncThunk(
    'events/defaultLoad',
    async ({ hours, days }, thunkAPI) => {
        try {
            let reqData = {
                vehicleName: null,
                fromDate: moment().subtract(days ?? 0, 'days').subtract(hours ?? 0, 'hours').format('YYYY-MM-DD hh:mm:ss'),
                toDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                eventDesc: null,
                limit: 25,
                offset: 0,
            };
            const apiData = await apiClient.post('/search_events_multi', reqData);
            return checkEventUserid(apiData.data.events, thunkAPI.getState, 25);
        } catch (error) {
            //console.log("Default Load events error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const getEventAddress = createAsyncThunk(
    'events/getEventAddress',
    async ({ searchParam }, thunkAPI) => {
        try {
            const { lat, lng, eventId, regn } = searchParam;
            const apiData = await apiClient.post('/get_address', { 'lat': lat, 'lng': lng });
            //console.log("Event address api", apiData.data);
            return { eventId, regn, address: apiData.data };
        } catch (error) {
            //console.log("Search events multi error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const checkSockEvent = (payload) => {

    return async (dispatch, getState) => {
        let goodev = [];
        const userid = getState().user.userid;
        payload.forEach(pl => {
            if (`${pl.user_id}` === `${userid}`) {
                goodev.push(pl);
            }
        })
        dispatch(socketNewEvent(goodev));
    }
}

const checkEventUserid = async (events, getState, limit) => {
    let goodev = [];
    const userid = getState().user.userid;
    //const userid = getState().user.parent_user;
    events.forEach(pl => {
        if (`${pl.user_id}` === `${userid}`) {
            goodev.push(pl);
        }
    })
    //console.log("returning goodev", getState().user, userid, goodev.length);
    return { limit, events: goodev };


}